import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "delivery-areas",
    title: "Where we deliver",
    body: [
      "nartvmora delivers only to destinations available in the country or region selector at checkout. Carrier limitations, sanctions, legal restrictions or a temporarily unavailable service can prevent delivery to some addresses.",
      "Provide a complete street address, postcode and reachable delivery location. We do not deliver to an address that the selected carrier cannot service.",
    ],
  },
  {
    id: "charges-estimates",
    title: "Delivery charge and estimate",
    table: [
      ["Standard shipping", "US$9.99 per non-empty order"],
      ["Checkout estimate", "Usually 3–7 business days after dispatch, subject to destination and carrier conditions"],
    ],
    body: [
      "The price and estimate displayed at checkout apply to the order. Delivery estimates are planning windows, not guaranteed arrival dates, and do not include order processing, weekends, public holidays, customs review or events outside reasonable control.",
    ],
  },
  {
    id: "processing",
    title: "Processing and dispatch",
    body: [
      "In-stock orders are normally prepared within one to two business days. Launches, promotions, address checks and peak periods may add up to three business days. A pre-order follows the estimate shown on its product page.",
      "A dispatch notice should include tracking after the carrier accepts the parcel. Tracking may take several hours to update.",
    ],
    links: [{ to: "/pre-orders", label: "Pre-order policy" }],
  },
  {
    id: "address-changes",
    title: "Address changes and delivery instructions",
    body: [
      "Email service@nartvmora.site immediately if an address is wrong. We may be able to correct it before fulfilment begins, but cannot guarantee a change or redirect once the carrier has the parcel.",
      "Authority-to-leave or safe-place instructions are subject to carrier availability. Do not select an unsecured location. A customer may be responsible for loss following delivery to the address, person or authorised safe place provided, except where applicable law says otherwise.",
    ],
  },
  {
    id: "customs",
    title: "Customs, duties and destination charges",
    body: [
      "Unless checkout expressly states that import charges have been collected, the recipient is responsible for any destination duty, tax, brokerage or carrier fee. These amounts are set by third parties and are not included in the product price.",
      "Customs authorities may request information from the recipient and may delay or refuse entry. We cannot mark a commercial order as a gift or declare a false value.",
    ],
  },
  {
    id: "split-orders",
    title: "Split shipments and pre-orders",
    body: [
      "An order may arrive in more than one parcel. Each dispatched parcel should receive its own tracking reference, and no extra delivery charge will be added after checkout without the customer's agreement.",
      "Available items ordered with a pre-order may be held for one shipment unless the product page or checkout states that separate dispatch is available.",
    ],
  },
  {
    id: "delays",
    title: "Delays",
    body: [
      "Weather, customs, transport disruption, high demand, government action and remote-area conditions can extend delivery. If tracking has not changed for five business days after the estimated arrival, contact us so an investigation can be opened with the carrier.",
    ],
  },
  {
    id: "failed-delivery",
    title: "Failed, refused or unclaimed delivery",
    body: [
      "A carrier may leave a collection notice or make another attempt. If a parcel is returned because the address was incomplete, delivery was refused, charges were not paid or it was not collected, we will contact the customer about redelivery or a refund.",
      "Reasonable non-refundable carrier or return costs may be deducted only where lawful and where the failure was caused by the customer. This does not limit rights for an incorrect, faulty or unlawfully delivered order.",
    ],
  },
  {
    id: "missing-damaged",
    title: "Missing, incorrect or damaged parcels",
    body: [
      "Check the delivery address, tracking, safe places and nearby collection points before reporting a parcel missing. Contact us promptly with the order reference. Visible transit damage should be photographed before packaging is discarded.",
      "We will assess the carrier record and provide any replacement, refund or other remedy required by applicable law. A carrier's scan does not remove a customer's right to show that delivery did not occur.",
    ],
    links: [
      { to: "/contact", label: "Report a delivery issue" },
      { to: "/consumer-guarantees", label: "Consumer guarantees" },
    ],
  },
];

function Delivery() {
  return (
    <PolicyLayout
      title="Shipping & Delivery"
      intro="Dispatch timing, delivery estimates, destination charges and help with a parcel."
      updated="Effective 16 October 2026"
      sections={sections}
      action={{ to: "/contact", label: "Ask about a delivery" }}
    />
  );
}

export default Delivery;
